export default __webpack_public_path__ + "static/media/Venturer's Helm of the Untamed.32395dee.jpg";